@if (model$ | async; as model) {
  <div class="cx-page">
    @if (model.products?.length>0) {
      <section class="cx-page-section">
        <div class="container">
          <div class="row">
            @if (viewMode$ | async; as viewMode) {
              <div class="col-12 col-lg-12">
                <div class="cx-sorting top">
                  <div class="row">
                    <div class="col-12 col-lg-4 mr-auto">
                      <div class="form-group cx-sort-dropdown">
                        <cx-sorting
                          [sortOptions]="model.sorts"
                          (sortListEvent)="sortList($event)"
                          [selectedOption]="model.pagination.sort"
                      placeholder="{{
                      'productList.sortBy' | cxTranslate
                    }}"
                        ></cx-sorting>
                      </div>
                    </div>
                    @if (!isInfiniteScroll) {
                      <div class="col-auto">
                        <div
                          class="cx-pagination"
                          aria-label="product search pagination"
                          >
                          <cx-pagination
                            [pagination]="model.pagination"
                            queryParam="currentPage"
                            [defaultPage]="0"
                          ></cx-pagination>
                        </div>
                      </div>
                    }
                    <div class="col-auto ml-auto ml-lg-0">
                      <cx-product-view
                        (modeChange)="setViewMode($event)"
                        [mode]="viewMode"
                      ></cx-product-view>
                    </div>
                  </div>
                </div>
                @if (banner$) {
                  <div class="row">
                    <span class="col-12 banner-container">
                      <ng-container *ngTemplateOutlet="componentTemplate; context: { item: banner$ | async }"></ng-container>
                    </span>
                  </div>
                }
                <div class="cx-product-container">
                  <ng-container>
                    <!-- Product list when using pagination -->
                    @if (!isInfiniteScroll) {
                      @if (viewMode === ViewModes.Grid) {
                        <div class="row">
                          @for (product of model?.products; track product) {
                            <app-efa-product-grid-item
                              [product]="product"
                              class="col-12 col-sm-6 col-md-4"
                              [id]="getProductCodeUrlEncoded(product.code)"
                            ></app-efa-product-grid-item>
                          }
                        </div>
                      }
                      @if (viewMode === ViewModes.List) {
                        @for (product of model?.products; track product) {
                          <app-efa-product-list-item
                            [product]="product"
                            [id]="getProductCodeUrlEncoded(product.code)"
                            class="cx-product-search-list"
                          ></app-efa-product-list-item>
                        }
                      }
                    } @else {
                      <app-efa-product-scroll
                        [scrollConfig]="scrollConfig"
                        [model]="model"
                        [inputViewMode]="viewMode"
                      ></app-efa-product-scroll>
                    }
                    <!-- Product list when using infinite scroll -->
                  </ng-container>
                </div>
                <div class="cx-sorting bottom">
                  <div class="row">
                    <div class="col-12 col-lg-4 mr-auto">
                      <div class="form-group cx-sort-dropdown">
                        <cx-sorting
                          [sortOptions]="model.sorts"
                          (sortListEvent)="sortList($event)"
                          [selectedOption]="model.pagination.sort"
                      placeholder="{{
                      'productList.sortBy' | cxTranslate
                    }}"
                        ></cx-sorting>
                      </div>
                    </div>
                    @if (!isInfiniteScroll) {
                      <div
                        class="col-auto"
                        aria-label="product search pagination"
                        >
                        <div class="cx-pagination">
                          <cx-pagination
                            [pagination]="model.pagination"
                            queryParam="currentPage"
                            [defaultPage]="0"
                          ></cx-pagination>
                        </div>
                      </div>
                    }
                    <div class="col-auto ml-auto ml-lg-0">
                      <cx-product-view
                        (modeChange)="setViewMode($event)"
                        [mode]="viewMode"
                      ></cx-product-view>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </section>
    }
  </div>
}
<ng-template #componentTemplate let-item="item">
  <ng-container [cxComponentWrapper]="{
      flexType: item.typeCode,
      typeCode: item.typeCode,
      uid: item?.uid,
    }">
  </ng-container>
</ng-template>
